import React, { useState, useEffect, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import axios from 'axios'

import AddBox from '@material-ui/icons/AddBox';
import PrintIcon from '@material-ui/icons/Print';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import moment from 'moment';
import localization from 'moment/locale/th';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import mockData from './image';
import bossLicense from './finance_boss_license';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Print: forwardRef((props, ref) => <PrintIcon {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  tableWrapper: {
    maxWidth: 3000,
    overflow: 'auto',
  },
  progress: {
    margin: theme.spacing(2),
  },
}));

const SlipsTable = props => {
  const classes = useStyles();
  const { slipData, tableHeader, slipMonth } = props;
  const [slipDatas, setEslipDatas] = useState([]);
  const [columns, setColumns] = useState();
  const [images] = useState(mockData);
  const [boss_license] = useState(bossLicense);
  const [profile] = useState(JSON.parse(localStorage.getItem('profile')));

  const months = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
  let source = axios.CancelToken.source();

  const currencyFormat = num => {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const setColumnsData = (data) => {
    let obj3 = [];
    obj3.push({
      title: 'เดือน', field: 'fullDate', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 150,
        color: '#3f51b5',
        fontWeight: "bold",
        padding: '5px'
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold",
        padding: '5px'
      },
    });

    obj3.push({
      title: 'รวมรายการได้', field: 'sumincome', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 130,
        color: '#0fca8d',
        fontWeight: "bold",
        padding: '5px'
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold",
        padding: '5px'
      },
    })

    obj3.push({
      title: 'รวมรายการหัก', field: 'sumdeduct', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 130,
        color: '#8c0808',
        fontWeight: "bold",
        padding: '5px'
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold",
        padding: '5px'
      },
    })

    obj3.push({
      title: 'รวมคงเหลือ', field: 'sumtotal', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 100,
        color: '#62a509',
        fontWeight: "bold",
        padding: '5px'
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold",
        padding: '5px'
      },
    })

    let headerTable = data.map(header => ({
      title: [header.tb_money_type.money_type_name].toString(),
      field: [header.money_type_id].toString(),
      type: 'numeric',
      cellStyle: {
        fontSize: 12,
        minWidth: 130,
        color: '#0f008d',
        padding: '5px'
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'right',
        fontWeight: "bold",
        padding: '5px'
      }
    }));
    obj3.push.apply(obj3, headerTable)
    setColumns(obj3);
  }

  const loadData = async () => {
    try {
      let newslip = [];
      const Months = slipMonth.map(month => ({
        payslip_for: month.payslip_for,
        fullDate: months[parseInt(month.payslip_for.substring(5).substring(0, 2)) - 1] + " " + (parseInt(month.payslip_for.substring(0, 4)) + 543),
      }));

      Months.forEach(month => {
        let d1 = new Date();
        let d2 = new Date(month.payslip_for);
        let d3 = new Date(d2.getUTCFullYear() + "-" + (parseInt(d2.getMonth()) + 1) + "-30");
      console.log(d1.getTime() - d3.getTime())
      const slips = slipData.filter((slip) => {
        //if (d1.getTime() - d3.getTime() > 86400000) {
          return (slip.payslip_for === month.payslip_for);
        //}
       // else {
        //  return false;
        //}

      })

      let sum_income = 0;
      let sum_deduct = 0;
      slips.forEach(slip => {
        (slip.tb_money_type.income_type_id === 1) ? (sum_income = sum_income + slip.TOTAL) : (sum_deduct = sum_deduct + slip.TOTAL);
        month = { ...month, [slip.money_type_id]: currencyFormat(slip.TOTAL) }
      });
      month = { ...month, sumincome: currencyFormat(sum_income) }
      month = { ...month, sumdeduct: currencyFormat(sum_deduct) }
      month = { ...month, sumtotal: currencyFormat(sum_income - sum_deduct) }
      newslip.push(month);
    });
    setEslipDatas(newslip);
  } catch (error) {
    console.log(error)
  }
};

useEffect(() => {
  const fetchData = async () => {
    try {
      setColumnsData(tableHeader);
      loadData();
    } catch (error) {
      console.log(error)
    }
  }
  fetchData()
  return () => {
    source.cancel();
  };
}, [slipData, tableHeader, slipMonth]);

const loadEtcData = async (payfor) => {
  try {
    const url = 'https://eslip.snru.ac.th/backend/api/eslipData/etcByPay/' + payfor;
    const result = await axios(url, {
      cancelToken: source.token
    });
    return (result.data.data)
  } catch (error) {

  }
};

const getAccountInfo = (citizenId) => {
  if (citizenId === '3900200217239') {
    return [
      { bank: 'กรุงไทย', account: '6987' },
      { bank: 'กรุงศรี', account: '7013' }
    ];
  } else if (citizenId === '3460600510990') {
    return [
      { bank: 'กรุงไทย', account: '4985' }
    ];
  } else {
    return null;
  }
};

const printSlip = async (data) => {
  pdfMake.fonts = {
    THSarabunNew: {
      normal: 'THSarabunNew.ttf',
      bold: 'THSarabunNew-Bold.ttf',
      italics: 'THSarabunNew-Italic.ttf',
      bolditalics: 'THSarabunNew-BoldItalic.ttf'
    },
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf'
    }
  }
  const slips = slipData.filter((slip) => {
    return slip.payslip_for === data.payslip_for
  })

  const etcdata = await loadEtcData(data.payslip_for);

  const etc = etcdata.filter((etc) => {
    return etc.citizen_id === profile.person.citizen_id
  })
  
  const customAccountInfo = getAccountInfo(profile.person.citizen_id);

  let list_income_name = [];
  let list_income_value = [];
  let list_deduct_name = [];
  let list_deduct_value = [];
  slips.forEach(slip => {
    if (slip.tb_money_type.income_type_id === 1) {
      list_income_name.push(slip.tb_money_type.money_type_name);
      list_income_value.push(currencyFormat(slip.TOTAL));
    } else {
      list_deduct_name.push(slip.tb_money_type.money_type_name);
      list_deduct_value.push(currencyFormat(slip.TOTAL));
    }
  });

  let docDefinition = {
    watermark: { text: 'มหาวิทยาลัยราชภัฏสกลนคร', color: 'green', opacity: 0.3, bold: true, italics: true },
    userPassword: profile.person.citizen_id,
    ownerPassword: profile.person.citizen_id,
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [20, 20, 20, 20],
    content: [
      {
        columns: [
          {
            image: images[0].image,
            width: 40
          },
          {
            text: [
              { text: 'มหาวิทยาลัยราชภัฏสกลนคร\n', style: 'header', alignment: 'left' },
              { text: 'เลขที่ 680 ถนนนิตโย ต. ธาตุเชิงชุม อำเภอเมือง จังหวัดสกลนคร 47000 \n โทรศัพท์ 042-970021,042-970094 IPPhone 932 โทรสาร 042-970022 E-mail webmaster@snru.ac.th', style: 'subheader', alignment: 'left' }
            ]
          },
          {
            width: 150,
            text: customAccountInfo 
              ? [
                  { text: 'เลขที่: ', style: 'header', alignment: 'right' },
                  { text: etc[0].auto_id, style: 'subheader', alignment: 'right' },
                  ...customAccountInfo.map((acc, idx) => [
                    { text: '\nบัญชี ' + acc.bank + " เลขที่: ", style: 'tableHeader', alignment: 'right' },
                    { text: 'XXXXXX' + acc.account, style: 'subheader', alignment: 'right' }
                  ]).flat()
                ]
              : [
                  { text: 'เลขที่: ', style: 'header', alignment: 'right' },
                  { text: etc[0].auto_id, style: 'subheader', alignment: 'right' },
                  { text: '\nบัญชี ' + etc[0].bank_name + " เลขที่: ", style: 'tableHeader', alignment: 'right' },
                  { text: 'XXXXXX' + etc[0].bank_account.substring(etc[0].bank_account.length - 4, etc[0].bank_account.length), style: 'subheader', alignment: 'right' }
                ]
          }
        ]
      },
      {
        columns: [
          {
            width: 35,
            text: 'ชื่อ - สกุล: \nเลขที่:', style: 'tableHeader', alignment: 'right'
          },
          {
            width: 115,
            text: profile.person.prefix_name + profile.person.fnamethai + " " + profile.person.lnamethai + "\n" + profile.person.position_num, style: 'table1', alignment: 'left'
          },
          {
            width: 50,
            text: 'ตำแหน่ง: \nหน่วยงาน:', style: 'tableHeader', alignment: 'right'
          },
          {
            width: 205,
            text: profile.person.position_name + "\n" + profile.person.agency_name, style: 'table1', alignment: 'left'
          },
          {
            width: 34,
            text: 'งวดที่จ่าย:\n', style: 'tableHeader', alignment: 'right'
          },
          {
            width: 70,
            text: data.fullDate, style: 'table1', alignment: 'left'
          }
        ]
      },
      {
        columns: [
          {
            table: {
              widths: [148, 52, 147, 52],
              heights: [20, 226, 20],
              body: [
                [
                  { text: 'รายได้\nIncome', style: 'tableHeader', alignment: 'center' },
                  { text: 'จำนวนเงิน\nAmount', style: 'tableHeader', alignment: 'center' },
                  { text: 'รายการหัก\nDeduction', style: 'tableHeader', alignment: 'center' },
                  { text: 'จำนวนเงิน\nAmount', style: 'tableHeader', alignment: 'center' }
                ],
                [
                  {
                    ol: list_income_name, style: 'table1', alignment: 'left'
                  },
                  {
                    type: 'none',
                    ol: list_income_value, style: 'table1', alignment: 'right'
                  },
                  {
                    ol: list_deduct_name, style: 'table1', alignment: 'left'
                  },
                  {
                    type: 'none',
                    ol: list_deduct_value, style: 'table1', alignment: 'right'
                  }
                ],
                [
                  { text: 'รวมรายได้\n(Total Incom)', style: 'tableHeader', alignment: 'right', fillColor: '#dddddd' },
                  { text: data.sumincome, style: 'tableHeader', alignment: 'right' },
                  { text: 'รวมรายการหัก\n(Total Deduction)', style: 'tableHeader', alignment: 'right', fillColor: '#dddddd' },
                  { text: data.sumdeduct, style: 'tableHeader', alignment: 'right' }
                ],
              ]
            }
          },
          [
            {
              style: 'tableExample',
              table: {
                widths: [100],
                body: [
                  [
                    {
                      text: 'วันที่พิมพ์สลิป\nPrint slip Date',
                      style: 'tableHeader',
                      fillColor: '#dddddd',
                      alignment: 'center'
                    },

                  ],
                  [
                    {
                      text: moment().locale("th", localization).format('DD MMMM') + " " + (parseInt(moment().locale("th", localization).format('YYYY')) + 543),
                      style: 'table2',
                      alignment: 'center'
                    },
                  ]
                ]
              }
            },
            {
              style: 'tableExample',
              table: {
                widths: [100],
                body: [
                  [
                    {
                      text: 'เงินได้สุทธิ\nNet to Pay',
                      style: 'tableHeader',
                      fillColor: '#dddddd',
                      alignment: 'center'
                    },

                  ],
                  [
                    {
                      text: data.sumtotal,
                      style: 'table2',
                      alignment: 'center'
                    },
                  ]
                ]
              }
            },
            {
              style: 'tableExample',
              margin: [0, 50, 0, 0],
              table: {
                widths: [100],
                body: [
                  [
                    {
                      text: 'ลายมือชื่อ',
                      style: 'tableHeader',
                      fillColor: '#dddddd',
                      alignment: 'center'
                    },

                  ],
                  /*[//ลายเซ็นต์พี่มาลัย
                    {
                      image: boss_license[0].image,
                      width: 60,
                      alignment: 'center'
                    }
                  ],*/
                  [
                    {
                      text: '\n.............................................\n\n(..............................................)',
                      style: 'table1',
                      fillColor: '#dddddd',
                      alignment: 'center'
                    },

                  ],
                ]
              }
            }
          ]
        ]
      },
    ],
    defaultStyle: {
      font: 'THSarabunNew',
      fontSize: 14,
      columnGap: 10
    },
    styles: {
      header: {
        fontSize: 14,
        bold: true
      },
      tableExample: {
        margin: [0, 0, 0, 15]
      },
      tableHeader: {
        fontSize: 12,
        bold: true,
        lineHeight: 0.8
      },
      tableHeader2: {
        fontSize: 12,
        bold: true,
        lineHeight: 0.8
      },
      table1: {
        fontSize: 12,
        lineHeight: 0.8
      },
      table2: {
        fontSize: 12,
        lineHeight: 1.5
      },
      subheader: {
        fontSize: 12,
      },
      quote: {
        italics: true
      },
      small: {
        fontSize: 10
      }
    }
  };
  // const win = window.open('', '_blank');
  //pdfMake.createPdf(docDefinition).print();
  pdfMake.createPdf(docDefinition).open();
}

return (
  <Paper className={classes.root}>
    <div className={classes.tableWrapper}>
      <MaterialTable
        icons={tableIcons}
        title="ข้อมูลรายการได้/รายการหัก บุคลากรมหาวิทยาลัยราชภัฏสกลนคร"
        columns={columns}
        data={slipDatas}
        options={{
          headerStyle: {
            backgroundColor: '#fafafa',
            color: '#333'
          }
        }}
        actions={[
          {
            tooltip: 'พิมพ์สลิปเงินเดือน',
            icon: () => <PrintIcon />,
            onClick: (evt, data) => printSlip(data)
          }
        ]}
      />
    </div>
  </Paper>
)
};

SlipsTable.propTypes = {
  className: PropTypes.string,
  slipData: PropTypes.array,
  tableHeader: PropTypes.array,
  slipMonth: PropTypes.array
};

export default SlipsTable;
